import axios from 'axios';
import {useMutation} from 'react-query';
import {mapFormToBackend} from '../utils/mapFormToBackend';

async function submitAlgoliaStyle({endpointUrl, formData}) {
  const payload = mapFormToBackend(formData);
  const response = await axios.put(endpointUrl, payload);
  return response.data;
}

/**
 * Custom hook for handling Algolia style submission using React Query
 * @param {string} endpointUrl - API endpoint URL
 * @param {Object} options - Additional mutation options
 * @returns {Object} React Query mutation object with additional utilities
 */
export default function useAlgoliaStyleMutation(endpointUrl, options = {}) {
  return useMutation({
    mutationFn: (formData) => submitAlgoliaStyle({endpointUrl, formData}),
    mutationKey: ['algoliaStyleMutation', endpointUrl],
    onError: (error, variables, context) => {
      if (options.onError) {
        options.onError(error, variables, context);
      }
    },
    onSuccess: (data, variables) => {
      if (options.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
    ...options
  });
}
